/* ============================================
   ReikoParis — Megamenu Translation Fix

   Problem: The Wokiee theme matches megamenu content by name
   (link.title | handleize), which breaks when the site is
   translated because the names change per language.

   This script fixes BOTH matching systems:
   1. mega_menu_index matching (Liquid) — we re-render
      menu items that lost their megamenu treatment
   2. data-name ↔ data-parent-megamenu matching (JS) —
      we use a known mapping to inject content correctly
   ============================================ */

(function() {
  'use strict';

  /* ---- Known megamenu name mappings ----
     English mega_menu_item_name → all known translations (handleized).
     Add more translations here as needed.
  */
  const MEGAMENU_MAP = {
    'new':       ['new', 'nouveau', 'nieuw', 'nueva', 'neu', 'nova'],
    'by-fit':    ['by-fit', 'par-fit', 'op-pasvorm', 'por-ajuste', 'nach-passform', 'per-vestibilita'],
    'signature': ['signature'],
    'lookbook':  ['lookbook', 'livre-de-visite', 'lookboek', 'libro-de-visitas', 'fotobuch'],
    'about':     ['about', 'a-propos', 'over-ons', 'acerca-de', 'uber-uns', 'chi-siamo']
  };

  const ABOUT_FALLBACK_LINKS = [];

  /* Build a reverse map: translated-handleized → english-handleized */
  const REVERSE_MAP = {};
  for (const [en, translations] of Object.entries(MEGAMENU_MAP)) {
    for (const t of translations) {
      REVERSE_MAP[t] = en;
    }
  }

  /* ---- Handleize: replicate Shopify's Liquid handleize filter in JS ---- */
  function handleize(text) {
    return text.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* ---- Fix 2: Inject external megamenu content using name mapping ---- */
  function fixMegamenuMatching() {
    const externalContainer = document.querySelector('external-megamenucontent');
    if (!externalContainer) return;

    /* Collect all external megamenu items with their data-name */
    const externalItems = externalContainer.querySelectorAll('[data-name]');
    if (!externalItems.length) return;

    /* Collect all rendered megamenu parent containers */
    const parentMegamenus = document.querySelectorAll('[data-parent-megamenu]');

    /* Build a map of english-name → parent element */
    const parentByEnglish = {};
    parentMegamenus.forEach(el => {
      const name = el.getAttribute('data-parent-megamenu');
      const englishName = REVERSE_MAP[name] || name;
      parentByEnglish[englishName] = el;
    });

    /* For each external item, try to match it to a parent */
    externalItems.forEach(item => {
      const name = item.getAttribute('data-name');
      const englishName = REVERSE_MAP[name] || name;

      const target = parentByEnglish[englishName];
      if (!target) return;

      /* Check if content was already injected by native code or previous run.
         We look for shopify-block children that are NOT fake-links —
         those are the actual banner/image items. The megamenu-group (link column)
         may already exist from Liquid rendering, so we don't count that. */
      if (target.querySelectorAll('[data-megamenu-index]').length > 0) return;
      const injectedImages = target.querySelectorAll('.shopify-block:not(.fake-links)');
      if (injectedImages.length > 0) return;

      /* Inject the megamenu content */
      Array.from(item.children).forEach((elem, index) => {
        if (elem.classList.contains('fake-links')) {
          const el = elem.children[0];
          const style = el && el.hasAttribute('style') ? el.getAttribute('style') : '';
          const targetChild = Array.from(target.children)[index];
          if (targetChild && style) {
            targetChild.setAttribute('style', style);
          }
        } else {
          const elem2 = elem.parentElement.removeChild(elem);
          elem2.setAttribute('data-megamenu-index', index);
          if (elem2.children.length > 0 && elem2.children[0].hasAttribute('style')) {
            elem2.setAttribute('style', elem2.children[0].getAttribute('style'));
          }
          target.appendChild(elem2);
        }
      });

      /* Remove fake-links placeholders */
      target.querySelectorAll('.fake-links').forEach(el => el.remove());

      /* Re-order by index */
      target.querySelectorAll('[data-megamenu-index]').forEach(elem => {
        const idx = Number(elem.getAttribute('data-megamenu-index'));
        const children = Array.from(target.children);
        if (idx >= 0 && idx < children.length) {
          target.insertBefore(elem, children[idx]);
        }
      });
    });
  }

  /* ---- Fix 1: Patch menu items that lost megamenu treatment ----
     When mega_menu_index matching fails (Liquid-side), the menu item
     renders as a simple dropdown instead of a megamenu. We detect this
     and convert it to a megamenu layout by copying the structure from
     a working megamenu item. Then we add JS hover listeners as a
     fallback to ensure the dropdown appears on hover.
  */
  function fixMegamenuLayout() {
    const menuItems = document.querySelectorAll('.list-menu--classic .list-menu--inline > li');

    menuItems.forEach(li => {
      const link = li.querySelector(':scope > a.list-menu__item');
      if (!link) return;

      /* Extract text, stripping icons/SVGs */
      const textNode = link.querySelector('span');
      if (!textNode) return;
      const titleText = textNode.textContent.trim().replace(/[\s\u00A0]+/g, ' ');
      const handleized = handleize(titleText);
      const englishName = REVERSE_MAP[handleized];

      if (!englishName) return;

      if (li.classList.contains('submenu--megamenu')) return;

      /* Check if there's a working megamenu li right after this one */
      const nextLi = li.nextElementSibling;
      if (nextLi && nextLi.classList.contains('megamenu-container')) return;

      /* This menu item should be a megamenu but isn't.
         Find a reference megamenu to clone the structure. */
      const referenceMegamenu = document.querySelector('li.megamenu-container');
      if (!referenceMegamenu) return;

      li.classList.add('submenu--megamenu', 'enable-scrollbar-megamenu-js');

      const simpleSubmenu = li.querySelector(':scope > .submenu-design__simple');
      var groups = [];
      if (simpleSubmenu) {
        var topItems = simpleSubmenu.querySelectorAll(':scope > ul > li');
        topItems.forEach(function(topLi) {
          var topLink = topLi.querySelector(':scope > a.submenu__item');
          if (!topLink) return;
          var nestedSubmenu = topLi.querySelector(':scope > .submenu-design__simple');
          if (nestedSubmenu) {
            var group = { heading: topLink.textContent.trim(), headingHref: topLink.href, links: [] };
            nestedSubmenu.querySelectorAll('a.submenu__item').forEach(function(sl) {
              group.links.push({ href: sl.href, text: sl.textContent.trim() });
            });
            groups.push(group);
          } else {
            if (groups.length === 0 || groups[groups.length - 1].heading) {
              groups.push({ heading: null, headingHref: null, links: [] });
            }
            groups[groups.length - 1].links.push({ href: topLink.href, text: topLink.textContent.trim() });
          }
        });
      }

      var refGridClass = 'page-grid-3';
      const refMega = document.querySelector('li.megamenu-container [class*="page-grid-"][data-parent-megamenu]');
      if (refMega) {
        var match = refMega.className.match(/page-grid-\d+/);
        if (match) refGridClass = match[0];
      }

      const megamenuLi = document.createElement('li');
      megamenuLi.className = 'submenu-container megamenu-container';

      const designDiv = document.createElement('div');
      designDiv.className = 'submenu-design__megamenu scrollbar-height-megamenu-js';

      const contentDiv = document.createElement('div');
      contentDiv.className = 'megamenu-container_content custom__scrollbar';

      const widthDiv = document.createElement('div');
      widthDiv.className = 'megamenu-page-width';

      const gridDiv = document.createElement('div');
      gridDiv.className = refGridClass;
      gridDiv.setAttribute('data-parent-megamenu', handleized);

      if (groups.length === 0 && englishName === 'about') {
        groups = [{ heading: null, headingHref: null, links: ABOUT_FALLBACK_LINKS.map(function(l) { return { href: l.path, text: l.text }; }) }];
      }

      var refGroup = document.querySelector('li.megamenu-container .megamenu-group');
      var groupStyle = '--column-count:1;';
      if (refGroup && refGroup.hasAttribute('style')) {
        groupStyle = refGroup.getAttribute('style');
      }

      groups.forEach(function(group) {
        var groupDiv = document.createElement('div');
        groupDiv.className = 'megamenu-group';
        groupDiv.setAttribute('style', groupStyle);

        if (group.heading) {
          var headingDiv = document.createElement('div');
          var headingLink = document.createElement('a');
          headingLink.href = group.headingHref || '#';
          headingLink.className = 'submenu__item submenu__item__level-2 megamenu-item megamenu-item__submenu--big h5 hover-area';
          headingLink.style.fontWeight = '600';
          var hSpan = document.createElement('span');
          var hInner = document.createElement('span');
          hInner.className = 'submenu__item_text';
          hInner.textContent = group.heading;
          hSpan.appendChild(hInner);
          headingLink.appendChild(hSpan);
          headingDiv.appendChild(headingLink);
          groupDiv.appendChild(headingDiv);
        }

        group.links.forEach(function(linkData) {
          var div = document.createElement('div');
          var newLink = document.createElement('a');
          newLink.href = linkData.href;
          newLink.className = 'submenu__item submenu__item__level-2 megamenu-item h5 hover-area';
          var span = document.createElement('span');
          var innerSpan = document.createElement('span');
          innerSpan.className = 'submenu__item_text';
          innerSpan.textContent = linkData.text;
          span.appendChild(innerSpan);
          newLink.appendChild(span);
          div.appendChild(newLink);
          groupDiv.appendChild(div);
        });

        gridDiv.appendChild(groupDiv);
      });

      widthDiv.appendChild(gridDiv);
      contentDiv.appendChild(widthDiv);
      designDiv.appendChild(contentDiv);
      megamenuLi.appendChild(designDiv);

      /* Insert the megamenu after the menu item */
      li.parentNode.insertBefore(megamenuLi, li.nextSibling);

      /* Remove the simple submenu dropdown */
      if (simpleSubmenu) {
        simpleSubmenu.remove();
      }

      /* ---- Add JS hover listeners as fallback ----
         The CSS adjacent sibling selector should handle hover,
         but we add JS listeners as well to guarantee it works
         for dynamically created megamenus.
      */
      addHoverListeners(li, megamenuLi);
    });
  }

  /* ---- Hover fallback: show/hide megamenu via JS events ---- */
  function addHoverListeners(triggerLi, megamenuLi) {
    let hideTimeout = null;

    function showMegamenu() {
      clearTimeout(hideTimeout);
      megamenuLi.style.display = 'block';
      megamenuLi.style.visibility = 'visible';
      megamenuLi.style.pointerEvents = 'none';
      const inner = megamenuLi.querySelector('.submenu-design__megamenu');
      if (inner) {
        inner.style.opacity = '1';
        inner.style.visibility = 'visible';
        inner.style.pointerEvents = 'auto';
        inner.style.top = '0';
      }
    }

    function hideMegamenu() {
      hideTimeout = setTimeout(() => {
        megamenuLi.style.display = '';
        megamenuLi.style.visibility = '';
        megamenuLi.style.pointerEvents = '';
        const inner = megamenuLi.querySelector('.submenu-design__megamenu');
        if (inner) {
          inner.style.opacity = '';
          inner.style.visibility = '';
          inner.style.pointerEvents = '';
          inner.style.top = '';
        }
      }, 50);
    }

    triggerLi.addEventListener('mouseenter', showMegamenu);
    triggerLi.addEventListener('mouseleave', hideMegamenu);
    megamenuLi.addEventListener('mouseenter', showMegamenu);
    megamenuLi.addEventListener('mouseleave', hideMegamenu);
  }

  function equalizeMegamenuHeights() {
    var megas = document.querySelectorAll('.megamenu-container .submenu-design__megamenu');
    if (megas.length < 2) return;
    var maxH = 0;
    megas.forEach(function(m) {
      m.style.minHeight = '';
      m.style.display = 'block';
      m.style.visibility = 'hidden';
      m.style.position = 'absolute';
      var h = m.scrollHeight;
      if (h > maxH) maxH = h;
      m.style.display = '';
      m.style.visibility = '';
      m.style.position = '';
    });
    if (maxH > 0) {
      megas.forEach(function(m) {
        m.style.minHeight = maxH + 'px';
      });
    }
  }

  function runFixes() {
    setTimeout(() => {
      fixMegamenuLayout();
      setTimeout(function() {
        fixMegamenuMatching();
        setTimeout(equalizeMegamenuHeights, 200);
      }, 100);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }

  window.addEventListener('reinit_megamenu', () => {
    setTimeout(runFixes, 300);
  });
})();
